/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherSearchResultDto { 
    calculatedDiscount?: number;
    code?: string;
    discountValue?: number;
    eligible?: boolean;
    endDate?: string;
    freeItemMode?: string;
    freeItemName?: string;
    id?: number;
    ineligibleReason?: string;
    maxDiscountAmount?: number;
    minimumSpend?: number;
    name?: string;
    startDate?: string;
    usageRemaining?: number;
    voucherType?: string;
}

